<template>
	<VueDatePicker
		v-model="time"
		:time-picker="true"
		:auto-apply="false"
		:clearable="false"
		:text-input="true"
		:locale="$i18n.locale"
		class="ao-great-time-picker ao-time-selector-of-date-range-picker"
		:select-text="$t('Apply')"
		:cancel-text="$t('Cancel')"
		:placeholder="$t('hh:mm')"
	/>
	<!-- class "ao-great-time-picker" не удалять, необходим -->
</template>

<script setup>
import { computed } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'

const props = defineProps({

	modelValue: {
		type: Object,
		default: () => (null),
	},

	debugMode: {
		type: Boolean,
		default: false,
	},

})

const emit = defineEmits({
	'update:modelValue': null,
})

const time = computed({
	get: () => {
		return props.modelValue
	},
	set: (value) => {
		if (props.debugMode) {
			// eslint-disable-next-line no-console
			console.log('date', value)
		}
		emit('update:modelValue', value)
	},
})
</script>

<style lang="scss">
.ao-time-selector-of-date-range-picker {

	.dp__input_wrap {

		.dp__input {
			width: 52px;
			border: none;
			border-bottom: 1px solid rgba(0, 0, 0, 0.36);
			border-radius: 0;
			padding: 2px 4px;
			font-size: 12px;
			font-weight: 400;
			line-height: 18px;
			// min-height: unset;
		}

		svg {
			display: none;
		}

	}

	.dp__action_button {
		font-size: 12px;
		outline: none;

		&.dp__action_cancel {
			border-color: rgba(var(--v-border-color), 0);

			&:hover {
				background-color: rgba(0, 0, 0, 0.04);
			}

		}

		&.dp__action_select {
			color: rgb(var(--v-theme-on-primary));
			background-color: rgb(var(--v-theme-primary));

			&:hover {
				background-color: rgba(var(--v-theme-primary), 0.9);
			}

		}

	}

}
</style>
